import { h2sSublayers } from '../../helper';
import { BLACK, Blue, Green, Grey, Orange, Red } from './popupHelper';

// MR (Mesure Réseau) layer id, used to override its legend with static entries
export const MR_LAYER_ID = 105;

// static legend entries for the MR (Mesure Réseau) layer, since the ArcGIS
// service does not expose a labeled renderer for this layer
export const getMrStaticLegend = () => [
  { imageData: null, svg: BLACK, label: 'Pas de télégestion' },
  { imageData: null, svg: Grey, label: 'Absence de remontée de la donnée' },
  { imageData: null, svg: Blue, label: "Risque d'encaissement faible (<60%)" },
  { imageData: null, svg: Green, label: "Risque d'encaissement normal (60-70%)" },
  { imageData: null, svg: Orange, label: "Risque d'encaissement élevé (70-90%)" },
  { imageData: null, svg: Red, label: "Risque d'encaissement très élevé (>90%)" },
];

// get ids layer
export const getLayerIds = (pType: string, pOption?: string) => {

  let ids: number[] = [];
  if (pType === 'do') {
    ids = [101, 106];
  } else if (pType === 'pr') {
    ids = [102, 105];
  } else if (pType === 'h2s') {
    ids = [h2sSublayers()[0]];
  } else if (pType === 'ecp') {
    ids = [107];
  } else if (pType === 'indus') {
    ids = [80];
  } else if (pType === 'hydro') {
    ids = [301, 302, 306];
  } else if (pType === 'pluie') {
    ids = [111, 110];
  } else {
    // milieu
    ids = pOption === 'sensibility' ? [108] : [109];
  }
  return ids;
};

// hide or show legend by click button
export const displayLegend = (pValue: string) => {
  let display;
  if (pValue === 'none') {
    display = 'block';
  } else {
    display = 'none';
  }
  return display;
};
